import styled from 'styled-components';

import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAISecond/components/Title';

export const SectionStyles = styled.section`
  margin: 40px auto 20px;
  padding: 0 16px;
  max-width: 540px;
`;

export const TitleStyles = styled(OwnAiTitle)`
  margin: 0 0 20px;
`;

export const PaymentOptionsWrapper = styled.div<{ $disabled?: boolean }>`
  ${({ $disabled }) =>
    $disabled &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;
